<template>
  <div style="overflow:auto;height:100%;">
    <v-container fluid fill-height grid-list-md style="padding:5px;">
      <v-layout fill-height column>
<!--        <v-flex style="height:50px;">-->
<!--          <a href="test.txt" download="test2.txt">test.txt</a>-->
<!--        </v-flex>-->
        <v-flex style="height:50px;">
          <v-btn flat style="color:white; background-color: rgb(51,82,128);height:30px;" @click="testPDF()">Export PDF</v-btn>
        </v-flex>

        <v-flex style="min-height:300px;">
          <v-layout row fill-height>
            <Gauge v-bind:data="gaugeData['ensp']" :height="225" :class="'gauge'"/>
          </v-layout>
        </v-flex>
        <v-flex style="min-height:300px;">
          <v-layout row fill-height>
            <Gauge v-bind:data="gaugeData['load']" :height="225" :class="'gauge'"/>
          </v-layout>
        </v-flex>

        <v-flex style="min-height:500px;">
          <v-layout row fill-height>
            <v-flex d-flex md3>
              <EngineState v-bind:data="engineData"/>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex style="min-height:500px;">
          <v-layout row fill-height>
            <v-flex d-flex md3>
              <SubsystemState v-bind:data="subSystemData"/>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex style="min-height:400px;">
          <v-layout row fill-height>
            <v-flex>
              <LoadDiagram v-if="active" v-bind:repClass="'report'" v-bind:flat="true" v-bind:active="active" v-bind:chartData="loadDiagram"/>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex style="background-color: white;">
                    <span style="width:100%;padding-top:5px;padding-bottom:5px; font-size: 24px !important; font-weight: 500; line-height: 1 !important;letter-spacing: 0.02em !important; color:rgb(51,82,128);">
                        Engine
                    </span>
          <v-layout fill-height column>
            <v-flex>
              <v-layout row style="height: 220px">
                <v-flex style="height: 220px">
                  <TimelineChart class="report-chart" v-bind:repClass="'report'" v-bind:active="active" v-bind:chartOptions="chartData['ensp']" v-bind:title="titles['ensp']"/>
                </v-flex>
              </v-layout>
              <v-layout row style="height: 220px">
                <v-flex style="height: 220px">
                  <TimelineChart class="report-chart" v-bind:repClass="'report'" v-bind:active="active" v-bind:chartOptions="chartData['load']" v-bind:title="titles['load']"/>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout row style="height: 220px">
                <v-flex style="height: 220px">
                  <TimelineChart class="report-chart" v-bind:repClass="'report'" v-bind:active="active" v-bind:chartOptions="chartData['shaftP']" v-bind:title="titles['shaftP']"/>
                </v-flex>
              </v-layout>
              <v-layout row style="height: 220px">
                <v-flex style="height: 220px">
                  <TimelineChart class="report-chart" v-bind:repClass="'report'" v-bind:active="active" v-bind:chartOptions="chartData['bsfc']" v-bind:title="titles['bsfc']"/>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout row style="height: 220px">
                <v-flex style="height: 220px">
                  <TimelineChart class="report-chart" v-bind:repClass="'report'" v-bind:active="active" v-bind:chartOptions="chartData['pscav']" v-bind:title="titles['pscav']"/>
                </v-flex>
              </v-layout>
              <v-layout row style="height: 220px">
                <v-flex style="height: 220px">
                  <TimelineChart class="report-chart" v-bind:repClass="'report'" v-bind:active="active" v-bind:chartOptions="chartData['tscav']" v-bind:title="titles['tscav']"/>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout row style="height: 220px">
                <v-flex style="height: 220px">
                  <TimelineChart class="report-chart" v-bind:repClass="'report'" v-bind:active="active" v-bind:chartOptions="chartData['soPresDispl']" v-bind:title="titles['soPresDispl']"/>
                </v-flex>
              </v-layout>
              <v-layout row style="height: 220px">
                <v-flex style="height: 220px">
                  <TimelineChart class="report-chart" v-bind:repClass="'report'" v-bind:active="active" v-bind:chartOptions="chartData['fRailPres']" v-bind:title="titles['fRailPres']"/>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex v-if="gasLayout">
              <v-layout row style="height: 220px">
                <v-flex style="height: 220px">
                  <TimelineChart v-bind:repClass="'report'" v-bind:active="active" v-bind:chartOptions="chartData['gasMode']" v-bind:title="titles['gasMode']"/>
                </v-flex>
              </v-layout>
              <v-layout row style="height: 220px">
                <v-flex style="height: 220px">
                  <TimelineChart v-bind:repClass="'report'" v-bind:active="active" v-bind:chartOptions="chartData['GasRailPress']" v-bind:title="titles['GasRailPress']"/>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex v-for="n in cylCount" :key="n" style="background-color: white; margin-top: 16px">
                    <span style="width:100%;padding-top:5px;padding-bottom:5px; font-size: 24px !important; font-weight: 500; line-height: 1 !important;letter-spacing: 0.02em !important; color:rgb(51,82,128);">
                        Cylinder {{ n }}
                    </span>
          <v-layout fill-height column>
            <v-flex>
              <v-layout row style="height: 220px">
                <v-flex style="height: 220px">
                  <TimelineChart class="report-chart" v-bind:repClass="'report'" v-bind:active="active" v-bind:chartOptions="chartData['pcomp'+n]" v-bind:title="titles['pcomp']"/>
                </v-flex>
              </v-layout>
              <v-layout row style="height: 220px">
                <v-flex style="height: 220px">
                  <TimelineChart class="report-chart" v-bind:repClass="'report'" v-bind:active="active" v-bind:chartOptions="chartData['pmax'+n]" v-bind:title="titles['pmax']"/>
                </v-flex>
              </v-layout>
              <v-layout row style="height: 220px">
                <v-flex style="height: 220px">
                  <TimelineChart class="report-chart" v-bind:repClass="'report'" v-bind:active="active" v-bind:chartOptions="chartData['pmaxPcomp'+n]" v-bind:title="titles['pmaxPcomp']"/>
                </v-flex>
              </v-layout>
              <v-layout row style="height: 220px">
                <v-flex style="height: 220px">
                  <TimelineChart class="report-chart" v-bind:repClass="'report'" v-bind:active="active" v-bind:chartOptions="chartData['tExhC'+n]" v-bind:title="titles['tExhC']"/>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex v-for="n in tcCount" :key="n" :style="'background-color: white; margin-top: 16px; padding-bottom:' + tcCount*9 + 'px;'">
                    <span style="height:10%;width:100%;padding-top:5px;padding-bottom:5px; font-size: 24px !important; font-weight: 500; line-height: 1 !important;letter-spacing: 0.02em !important; color:rgb(51,82,128);">
                        T/C {{ n }}
                    </span>
          <v-layout fill-height column>
            <v-flex>
              <v-layout row style="height: 220px">
                <v-flex style="height: 220px">
                  <TimelineChart class="report-chart" v-bind:repClass="'report'" v-bind:active="active" v-bind:chartOptions="chartData['tcspeed'+n]" v-bind:title="titles['tcspeed']"/>
                </v-flex>
              </v-layout>
              <v-layout row style="height: 220px">
                <v-flex style="height: 220px">
                  <TimelineChart class="report-chart" v-bind:repClass="'report'" v-bind:active="active" v-bind:chartOptions="chartData['tTurbIn'+n]" v-bind:title="titles['tTurbIn']"/>
                </v-flex>
              </v-layout>
              <v-layout row style="height: 220px">
                <v-flex style="height: 220px">
                  <TimelineChart class="report-chart" v-bind:repClass="'report'" v-bind:active="active" v-bind:chartOptions="chartData['tcTbroilIn'+n]" v-bind:title="titles['tcTbroilIn']"/>
                </v-flex>
              </v-layout>
              <v-layout row style="height: 220px">
                <v-flex style="height: 220px">
                  <TimelineChart class="report-chart" v-bind:repClass="'report'" v-bind:active="active" v-bind:chartOptions="chartData['tcTbroilO'+n]" v-bind:title="titles['tcTbroilO']"/>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex v-if="showAdditional" :style="'background-color: white; margin-top: 16px; padding-bottom:' + isoParams['ensp'].length*9 + 'px;'">
          <span style="height:3%;width:100%;padding-top:5px;padding-bottom:5px; font-size: 24px !important; font-weight: 500; line-height: 1 !important;letter-spacing: 0.02em !important; color:rgb(51,82,128);">Data Curves ISO</span>
          <span style="display: block; height: initial; width: 100%; padding: 5px 16px; font-size: 20px !important; font-weight: 500; font-family: 'Roboto', sans-serif !important; line-height: 20px; letter-spacing: 0.4px; flex-wrap: wrap; align-items: center">ISO - corrected curves vs. engine speed</span>
          <v-layout fill-height column>
            <v-layout v-for="isoParam in isoParams['ensp']" :key="isoParam" row style="height: 220px">
              <v-flex style="height:220px;">
                <BarChart class="report-chart" v-if="isoData['ensp'] && isoData['ensp'][isoParam[0]]" v-bind:active="active" v-bind:chartOptions="isoData['ensp'][isoParam[0]]" v-bind:flat="true" title=""/>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-flex>
        <v-flex v-if="showAdditional" style="background-color: white; margin-top: 16px">
          <span style="height:5%;width:100%;padding-top:5px;padding-bottom:5px; font-size: 24px !important; font-weight: 500; line-height: 1 !important;letter-spacing: 0.02em !important; color:rgb(51,82,128);">Tunings</span>
          <v-layout fill-height column>
            <v-layout row :style="'margin-top: 8px'">
              <v-flex>
                <span style="display: block; height: initial; width: 100%; padding: 5px 16px; font-size: 20px !important; font-weight: 500; font-family: 'Roboto', sans-serif !important; line-height: 20px; letter-spacing: 0.4px; flex-wrap: wrap; align-items: center">Rail Pressures</span>
                <v-layout column>
                  <v-layout row style="height:200px;">
                    <v-flex style="height:200px;">
                      <BarChart class="report-chart" v-if="tuningData['loadvfRailPres']" v-bind:active="active" v-bind:chartOptions="tuningData['loadvfRailPres']" v-bind:flat="true" title=""/>
                    </v-flex>
                  </v-layout>
                  <v-layout row style="height:200px;">
                    <v-flex style="height:200px;">
                      <BarChart class="report-chart" v-if="tuningData['loadvsoPresDispl']" v-bind:active="active" v-bind:chartOptions="tuningData['loadvsoPresDispl']" v-bind:flat="true" title=""/>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row :style="'margin-top: 8px'">
              <v-flex>
                <span style="display: block; height: initial; width: 100%; padding: 5px 16px; font-size: 20px !important; font-weight: 500; font-family: 'Roboto', sans-serif !important; line-height: 20px; letter-spacing: 0.4px; flex-wrap: wrap; align-items: center">Electronic VIT</span>
                <v-layout column>
                  <v-layout row style="height: 220px;max-height: 220px;">
                    <v-flex style="height: 220px;max-height: 220px;">
                      <BarChart class="report-chart" v-if="tuningData['pscav_relvvit_a']" v-bind:active="active" v-bind:chartOptions="tuningData['pscav_relvvit_a']" v-bind:flat="true" title=""/>
                    </v-flex>
                  </v-layout>
                  <v-layout row style="height: 220px;max-height: 220px;">
                    <v-flex style="height: 220px;max-height: 220px;">
                      <BarChart class="report-chart" v-if="tuningData['ensp_relvvit_b']" v-bind:active="active" v-bind:chartOptions="tuningData['ensp_relvvit_b']" v-bind:flat="true" title=""/>
                    </v-flex>
                  </v-layout>
                  <v-layout row style="height: 220px;max-height: 220px;">
                    <v-flex style="height: 220px;max-height: 220px;">
                      <BarChart class="report-chart" v-if="tuningData['fRailPresvvit_c']" v-bind:active="active" v-bind:chartOptions="tuningData['fRailPresvvit_c']" v-bind:flat="true" title=""/>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex>
                <span style="display: block; height: initial; width: 100%; padding: 5px 16px; font-size: 20px !important; font-weight: 500; font-family: 'Roboto', sans-serif !important; line-height: 20px; letter-spacing: 0.4px; flex-wrap: wrap; align-items: center">Electronic VIT</span>
                <v-layout column>
                  <v-layout row style="height: 220px;max-height: 220px;">
                    <v-flex style="height: 220px;max-height: 220px;">
                      <BarChart class="report-chart" v-if="tuningData['ensp_relvvec']" v-bind:active="active" v-bind:chartOptions="tuningData['ensp_relvvec']" v-bind:flat="true" title=""/>
                    </v-flex>
                  </v-layout>
                  <v-layout row style="height: 220px;max-height: 220px;">
                    <v-flex style="height: 220px;max-height: 220px;">
                      <BarChart class="report-chart" v-if="tuningData['pscav_relvvec']" v-bind:active="active" v-bind:chartOptions="tuningData['pscav_relvvec']" v-bind:flat="true" title=""/>
                    </v-flex>
                  </v-layout>
                  <v-layout row style="height: 220px;max-height: 220px;">
                    <v-flex style="height: 220px;max-height: 220px;">
                      <BarChart class="report-chart" v-if="tuningData['ensp_relvveo']" v-bind:active="active" v-bind:chartOptions="tuningData['ensp_relvveo']" v-bind:flat="true" title=""/>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-flex>
        <v-flex v-if="showAdditional" style="min-height:1000px;">
          <v-layout column style="height:100%;width:100%">
            <v-flex d-flex md6>
              <dx-data-grid class="perfTable" :data-source="signalsLeft" :show-column-lines="true" :show-row-lines="true" :show-borders="false" :word-wrap-enabled="true" :row-alternation-enabled="true" :column-auto-width="true">
                <dx-scrolling mode="virtual"/>
              </dx-data-grid>
            </v-flex>
            <v-flex d-flex md6>
              <dx-data-grid class="perfTable" :data-source="signalsRight" :show-column-lines="true" :show-row-lines="true" :show-borders="false" :word-wrap-enabled="true" :row-alternation-enabled="true" :column-auto-width="true">
                <dx-scrolling mode="virtual"/>
              </dx-data-grid>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

import {DxDataGrid, DxColumn, DxPaging, DxScrolling} from 'devextreme-vue/data-grid';

import TimelineChart from '../controls/TimelineChart'
import BarChart from '../controls/BarChart'
import LoadDiagram from '../controls/LoadDiagram'

import EngineState from '../controls/EngineState'
import SubsystemState from '../controls/SubsystemState'
import FaultsWidget from '../controls/FaultsWidget'
import Gauge from '../controls/Gauge'

import {globalStore, vessels} from "../main.js"

import axios from 'axios';

import Highcharts from 'highcharts'
import {Chart} from 'highcharts-vue'
import More from 'highcharts/highcharts-more'

More(Highcharts)

export default {
  name: "Daily Report",
  components: {
    TimelineChart,
    LoadDiagram,
    EngineState,
    SubsystemState,
    FaultsWidget,
    Gauge,
    BarChart,
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxScrolling
    // Highcharts
  },
  data() {
    return {
      chartData: {},
      tuningData: {},
      titles: {},
      isoData: {},
      isoParams: {
        'ensp': [["pmax_ISO", "pcomp_ISO"], ["tTurbIn_ISO", "tTurbO_ISO"], ["tcspeed_ISO"], ["pscav_ISO"], ["fCmd"], ["shaftP"], ["bsfc_ISO"]],
        'shaftP': [["pmax_ISO", "pcomp_ISO"], ["tTurbIn_ISO", "tTurbO_ISO"], ["tcspeed_ISO"], ["pscav_ISO"], ["fCmd"], ["ensp"], ["bsfc_ISO"]]
      },
      subSystemData: [],
      engineData: {
        cylinders: [],
        elements: [],
        engineKPI: 0,
        engineColor: 0
      },
      loadDiagram: {},
      gaugeData: {},
      active: false, fields: ['load', 'ensp', 'shaftP', 'fCmd', 'vol_inj', 'tors', 'vit_a', 'vit_b', 'vit_c', 'vit_d', 'soi_com', 'off_inj', 'fqs', 'pscav', 'pscav_cmcr', 'soPresDispl', 'soPresSetpoint', 'fRailPres', 'fRailPresSet', 'vitOn', 'analWasteGatePos', 'activeInjNozzles', 'tcspeed', 'tcPbroilIn1', 'bsfc', 'ftemp'],
      avgFields: ['EC_Inj_DurationCyl', 'evo', 'evcAngleSet', 'JCWOut', 'sloc'],
      cylFields: ['pcomp', 'pmax', 'tExhC'],
      tcFields: ['tTurbIn', 'tTurbO', 'tcPbroilIn', 'tcTbroilIn', 'tcTbroilO', 'cwAcIn', 'cwAcOu'],
      meanFields: ['pAmb', 'tbli', 'tscav'],
      signalsLeft: [],
      signalsRight: []
    }
  },
  created() {
  },
  computed: {
    dataLoaded: function () {
      return globalStore.type;
    },
    showAdditional: function () {
      if (globalStore.userProfile.roles.includes('ROLE_WINGD_USER'))
        return true;
      else
        return false;
    },
    cylCount: function () {
      return globalStore.cylCount;
    },
    tcCount: function () {
      return globalStore.tcCount;
    },
    gasLayout: function () {
      return globalStore.gasEngine;
    },
  },
  mounted() {
    var mapping = globalStore.mapping[globalStore.selectedIMO];

    if (typeof mapping == 'undefined') {
      mapping = globalStore.mapping[Object.keys(globalStore.mapping)[0]]
    }

    let params = ['ensp', 'shaftP', 'load', 'pscav', 'tscav', 'soPresDispl', 'fRailPres', 'bsfc', 'pcomp', 'pmax', 'pmaxPcomp', 'tExhC', 'tcspeed', 'tTurbIn', 'tcTbroilIn', 'tcTbroilO'];

    for (let p = 0; p < params.length; p++) {
      this.$set(this.titles, params[p], mapping['mapping'][params[p]]);
    }
    this.$set(this.titles, 'gasMode', 'Engine Mode');
    this.$set(this.titles, 'GasRailPress', 'Gas Rail Pressure');

    setTimeout(() => {
      this.setData();
    }, 600);

  },
  methods: {
    setData() {
      var mapping = globalStore.mapping[globalStore.selectedIMO],
          units = globalStore.units[globalStore.selectedIMO],
          limits = globalStore.limits[globalStore.selectedIMO];

      if (typeof mapping == 'undefined') {
        mapping = globalStore.mapping[Object.keys(globalStore.mapping)[0]]
      }

      if (typeof units == 'undefined') {
        units = globalStore.units[Object.keys(globalStore.units)[0]]
      }

      if (typeof limits == 'undefined') {
        limits = globalStore.limits[Object.keys(globalStore.limits)[0]]
      }

      this.active = false;

      let refLength = Object.keys(globalStore.reference).length,
          sigLength = Object.keys(globalStore.signals).length,
          key = ((refLength > sigLength) ? 'signals' : 'reference'),
          timeStamps = globalStore[key].timestamps,
          timestamp = timeStamps[timeStamps.length - 1];

      if (Object.keys(globalStore.signals).indexOf('average') > -1) {
        timestamp = 'average';
      }

      if (typeof globalStore.reference[timestamp] != 'undefined') {
        if (timeStamps.indexOf('average') > -1)
          timeStamps.splice(timeStamps.indexOf('average'), 1);

        this.$set(this.engineData, 'engineColor', globalStore.reference[timestamp]['eng_KPI_color']);

        let kpi = globalStore.reference[timestamp]['eng_KPI'] * 100;

        if (kpi.toFixed(1) != '100.0')
          this.$set(this.engineData, 'engineKPI', kpi.toFixed(1));
        else
          this.$set(this.engineData, 'engineKPI', kpi.toFixed(0));

        this.engineData.cylinders = [];

        for (let c = 1; c <= this.cylCount; c++)
          this.engineData.cylinders.push(globalStore.reference[timestamp]['cyl' + c + '_KPI_color']);

        let names = ['Turbines', 'Compressors', 'A/F', 'A/C'],
            tags = ['turb', 'comp', 'ac', 'af'];

        this.engineData.elements = [];

        for (let el = 0; el < names.length; el++) {
          let sum = 0;

          for (let t = 1; t <= this.tcCount; t++) {
            sum += globalStore.reference[timestamp][tags[el] + t + '_KPI_color'];
          }

          this.engineData.elements.push({
            name: names[el],
            color: sum / this.tcCount
          });
        }

        names = ['Servo Oil', 'Exhaust Gas', 'Piston Running', 'Fuel Injection', 'Scavenge Air', 'Automation & Control'];
        tags = ['so_KPI_color', 'egs_KPI_color', 'pr_KPI_color', 'fi_KPI_color', 'sac_KPI_color', 'ca_KPI_color'];

        this.subSystemData = [];

        for (let sys = 0; sys < names.length; sys++) {
          this.subSystemData.push({
            system: names[sys],
            value: globalStore.reference[timestamp][tags[sys]]
          });
        }

        let params = ['ensp', 'shaftP', 'load', 'bsfc', 'pscav', 'tscav', 'soPresDispl', 'fRailPres'],
            refs = ['', 'shaftP', '', 'bsfc', 'pscav', 'tscav', 'soPresSetpoint', 'fRailPresSet'];

        for (let p = 0; p < params.length; p++) {
          this.$set(this.chartData, params[p], {
            credits: {enabled: false},
            time: {
              useUTC: false
            },
            chart: {
              height: 500,
              zoomType: 'xy'
            },
            xAxis: {
              type: 'datetime',
              title: {
                text: 'Time',
                align: 'high'
              },
              labels: {
                format: ((typeof globalStore.dateTo == 'undefined' || globalStore.dateTo.length < 1) ? '{value:%H:%M}' : '{value:%m-%e}'),
              },
              crosshair: true
            },
            yAxis: {
              title: {
                text: '[' + ((params[p] == 'load') ? '%' : units[params[p]]) + ']',
                align: 'high'
              }
            },
            exporting: {
              enabled: false
            },
            tooltip: {
              formatter: function () {
                var s = '<b>' + Highcharts.dateFormat('%Y-%m-%d %H:%M', this.x) + '</b>',
                    actTime = this.x, allSeries = [];

                if (this.points){
                  allSeries = this.points[0].series.chart.series
                } else {
                  allSeries = this.point.series.chart.series;
                }

                allSeries.forEach(series => {

                  if (series.name != 'State') {
                    var diff = series.closestPointRange, actPoint = null;

                    series.data.forEach(point => {
                      let temp = Math.abs(actTime - point.x)

                      if (temp < diff) {
                        actPoint = point;
                        diff = temp;
                      }
                    });

                    if (actPoint != null) {
                      if (actPoint.series.type == 'scatter') {
                        s += '<br/> ' + actPoint.series.name + ': ' + actPoint.y.toFixed(2);
                      } else {
                        s += '<br/> ' + actPoint.series.name + ': from ' + actPoint.low.toFixed(2) + ' to ' + actPoint.high.toFixed(2);
                      }
                    }
                  }
                });
                return s;
              },
              shared: true
            },
            legend: {
              enabled: false
            },
            title: {
              text: undefined
            },
            series: [
              {
                name: 'Value',
                type: 'scatter',
                animation: false,
                data: [],
                marker: {
                  radius: 2
                },
                states: {
                  hover: {
                    enabled: false
                  },
                  normal: {
                    animation: false
                  },
                  inactive: {
                    opacity: 1
                  }
                }
              },
              {
                name: 'Acceptable Range',
                type: 'arearange',
                animation: false,
                data: [],
                marker: {
                  enabled: false
                },
                color: 'rgb(219, 219, 219)',
                fillOpacity: 0.6,
                states: {
                  hover: {
                    enabled: false
                  },
                  normal: {
                    animation: false
                  },
                  inactive: {
                    opacity: 1
                  }
                }
              },
              {
                name: 'State',
                type: 'line',
                color: 'transparent',
                animation: false,
                data: [],
                marker: {
                  radius: 0
                },
                states: {
                  hover: {
                    enabled: false
                  },
                  normal: {
                    animation: false
                  },
                  inactive: {
                    opacity: 1
                  }
                }
              },
            ],
          });

          for (let i = 0; i < timeStamps.length; i++) {
            let val, rfr;

            val = globalStore.signals[timeStamps[i]][params[p]];

            if ((val == -1000) && (params[p] == 'shaftP')) {
              let mcr = globalStore.loadDiagram['otVal1'];

              if (globalStore.signals[timeStamps[i]]['ME_Power_kW'] != -1000)
                val = globalStore.signals[timeStamps[i]]['ME_Power_kW'];
              else if (globalStore.signals[timeStamps[i]]['load'] != -1000)
                val = globalStore.signals[timeStamps[i]]['load'] * mcr;
            }

            if (params[p] == 'fRailPres')
              rfr = globalStore.signals[timeStamps[i]][refs[p]];
            else if ((globalStore.reference.timestamps.includes(timeStamps[i])) && (refs[p] != '')) {
              rfr = globalStore.reference[timeStamps[i]][refs[p]];
            } else
              rfr = -1000;

            let color = 'rgb(51,82,128)',
                dt = new Date(timeStamps[i]);

            if ((val != -1000) && (rfr != -1000) && (Object.keys(limits).includes(params[p]))) {
              let minLimit = limits[params[p]][0], maxLimit = limits[params[p]][1];

              if ((minLimit != null) && (maxLimit != null)) {
                let temp = ((val - rfr) / val) * 100;

                if ((temp > minLimit) && (temp < maxLimit))
                  color = 'rgb(60, 171, 48)';
                else
                  color = 'rgb(255, 184, 29)';

                let min = rfr / (1 - minLimit / 100),
                    max = rfr / (1 - maxLimit / 100);

                this.chartData[params[p]].series[1].data.push({
                  x: dt,
                  low: min,
                  high: max
                });
              }
            }

            if (val != -1000) {
              this.chartData[params[p]].series[0].data.push({
                x: dt,
                y: ((params[p] == 'load') ? val * 100 : val),
                color: color
              });
            }
          }
        }

        if (globalStore.gasEngine) {
          this.$set(this.chartData, 'gasMode', {
            credits: {enabled: false},
            time: {
              useUTC: false
            },
            chart: {
              height: 100,
              zoomType: 'xy'
            },
            xAxis: {
              type: 'datetime',
              title:
                  {
                    text: 'Time',
                    align: 'high'
                  },
              labels: {
                format: '{value:%H:%M}'
              },
              crosshair: true
            },
            yAxis: {
              title: {
                text: undefined
              },
              categories: ['Diesel', 'Gas']
            },
            exporting: {
              enabled: false
            },
            tooltip: {
              formatter: function () {
                return this.points.reduce(function (s, point) {
                  // if (point.series.type=='line')
                  // {
                  return s + '<br/>' + point.series.name + ': ' + point.series.yAxis.categories[point.y];
                  // }
                  // else
                  // {
                  //   return s + '<br/>' + point.series.name + ': from ' + point.point.low.toFixed(2) + ' to ' + point.point.high.toFixed(2);
                  // }
                }, '<b>' + new Date(this.x).toTimeString().substring(0, 5) + '</b>');
              },
              shared: true
            },
            legend: {
              enabled: false
            },
            title: {
              text: undefined
            },
            series: [{
              name: 'Engine Mode',
              type: 'line',
              step: 'center',
              color: 'rgb(51,82,128)',
              animation: false,
              data: [],
              marker:
                  {
                    enabled: false
                  },
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            }]
          });

          this.$set(this.chartData, 'GasRailPress', {
            credits: {enabled: false},
            time: {
              useUTC: false
            },
            chart: {
              height: 100,
              zoomType: 'xy'
            },
            xAxis: {
              type: 'datetime',
              title:
                  {
                    text: 'Time',
                    align: 'high'
                  },
              labels: {
                format: '{value:%H:%M}'
              },
              crosshair: true
            },
            yAxis: {
              title:
                  {
                    text: '[bar]',
                    align: 'high'
                  }
            },
            exporting: {
              enabled: false
            },
            tooltip: {
              formatter: function () {
                return this.points.reduce(function (s, point) {
                  if (point.series.type == 'line') {
                    return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(2);
                  } else {
                    return s + '<br/>' + point.series.name + ': from ' + point.point.low.toFixed(2) + ' to ' + point.point.high.toFixed(2);
                  }
                }, '<b>' + new Date(this.x).toTimeString().substring(0, 5) + '</b>');
              },
              shared: true
            },
            legend: {
              enabled: false
            },
            title: {
              text: undefined
            },
            series: [{
              name: 'Fuel Side',
              type: 'line',
              color: 'transparent',
              animation: false,
              data: [],
              marker:
                  {
                    radius: 3
                  },
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            }, {
              name: 'Exhaust Side',
              type: 'line',
              color: 'transparent',
              animation: false,
              data: [],
              marker:
                  {
                    radius: 3
                  },
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            },
              {
                name: 'Acceptable Range',
                type: 'arearange',
                animation: false,
                data: [],
                marker: {
                  enabled: false
                },
                color: 'rgb(219, 219, 219)',
                fillOpacity: 0.6,
                states: {
                  hover: {
                    enabled: false
                  },
                  normal: {
                    animation: false
                  },
                  inactive: {
                    opacity: 1
                  }
                }
              }]
          });

          for (let i = 0; i < timeStamps.length; i++) {
            let gas = globalStore.signals[timeStamps[i]]['gasOn'];
            let dt = new Date(timeStamps[i]);

            let fuel = globalStore.signals[timeStamps[i]]['GasRailPress1'];
            let exhaust = globalStore.signals[timeStamps[i]]['GasRailPress2'];

            if (gas != -1000) {
              if (gas == 0)
                this.chartData['gasMode'].series[0].data.push({
                  x: dt,
                  y: 0
                });
              else
                this.chartData['gasMode'].series[0].data.push({
                  x: dt,
                  y: 1
                });
            }

            let rfr = -1000;

            if (Object.keys(globalStore.signals[timeStamps[i]]).includes('GasRailPressSetPoint')) rfr = globalStore.signals[timeStamps[i]]['GasRailPressSetPoint'];

            let fuelColor = 'rgb(51,82,128)', exhColor = 'rgb(51,82,128)';

            if ((rfr != -1000) && (Object.keys(limits).includes('GasRailPress'))) {
              let minLimit = limits['GasRailPress'][0], maxLimit = limits['GasRailPress'][1];

              if ((minLimit != null) && (maxLimit != null)) {
                let fuelTemp = ((fuel - rfr) / fuel) * 100;
                let exhTemp = ((exhaust - rfr) / exhaust) * 100;

                if ((fuelTemp > minLimit) && (fuelTemp < maxLimit)) fuelColor = 'rgb(60, 171, 48)';
                else fuelColor = 'rgb(255, 184, 29)';

                if ((exhTemp > minLimit) && (exhTemp < maxLimit)) exhColor = 'rgb(60, 171, 48)';
                else exhColor = 'rgb(255, 184, 29)';

                let min = rfr / (1 - minLimit / 100);
                let max = rfr / (1 - maxLimit / 100);

                this.chartData['GasRailPress'].series[2].data.push({
                  x: dt,
                  low: min,
                  high: max
                });
              }
            }

            if (fuel != -1000)
              this.chartData['GasRailPress'].series[0].data.push({
                x: dt,
                y: fuel,
                color: fuelColor
              });

            if (exhaust != -1000)
              this.chartData['GasRailPress'].series[1].data.push({
                x: dt,
                y: exhaust,
                color: exhColor
              });


          }
        }

        params = ['pcomp', 'pmax', 'pmaxPcomp', 'tExhC'];
        refs = ['pcomp', 'pmax', 'pmaxPcomp', 'tExhC'];

        for (let c = 1; c <= this.cylCount; c++) {
          for (let p = 0; p < params.length; p++) {
            this.$set(this.chartData, params[p] + c, {
              credits: {enabled: false},
              time: {
                useUTC: false
              },
              chart: {
                height: 100,
                zoomType: 'xy'
              },
              xAxis: {
                type: 'datetime',
                title: {
                  text: 'Time',
                  align: 'high'
                },
                labels: {
                  format: '{value:%H:%M}'
                },
                crosshair: true
              },
              yAxis: {
                title: {
                  text: '[' + units[params[p]] + ']',
                  align: 'high'
                }
              },
              exporting: {
                enabled: false
              },
              tooltip: {
                formatter: function () {
                  return this.points.reduce(function (s, point) {
                    if (point.series.type == 'line') {
                      return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(2);
                    } else {
                      return s + '<br/>' + point.series.name + ': from ' + point.point.low.toFixed(2) + ' to ' + point.point.high.toFixed(2);
                    }
                  }, '<b>' + new Date(this.x).toTimeString().substring(0, 5) + '</b>');
                },
                shared: true
              },
              legend: {
                enabled: false
              },
              title: {
                text: undefined
              },
              series: [
                {
                  name: 'Value',
                  type: 'line',
                  color: 'transparent',
                  animation: false,
                  data: [],
                  marker:
                      {
                        radius: 2
                      },
                  states: {
                    hover: {
                      enabled: false
                    },
                    normal: {
                      animation: false
                    },
                    inactive: {
                      opacity: 1
                    }
                  }
                },
                {
                  name: 'Acceptable Range',
                  type: 'arearange',
                  animation: false,
                  data: [],
                  marker: {
                    enabled: false
                  },
                  color: 'rgb(219, 219, 219)',
                  fillOpacity: 0.6,
                  states: {
                    hover: {
                      enabled: false
                    },
                    normal: {
                      animation: false
                    },
                    inactive: {
                      opacity: 1
                    }
                  }
                }
              ]
            });

            // for (let i = 0; i < timeStamps.length; i++) {
            for (let i = 0; i < timeStamps.length; i += 3) {
              let val, rfr;

              val = globalStore.signals[timeStamps[i]][params[p] + c];

              if (globalStore.reference.timestamps.includes(timeStamps[i]))
                rfr = globalStore.reference[timeStamps[i]][refs[p] + c];
              else
                rfr = -1000;

              let color = 'rgb(51,82,128)';

              let dt = new Date(timeStamps[i]);

              if ((val != -1000) && (rfr != -1000) && (Object.keys(limits).includes(params[p]))) {
                let minLimit = limits[params[p]][0],
                    maxLimit = limits[params[p]][1];

                if ((minLimit != null) && (maxLimit != null)) {

                  let temp = ((val - rfr) / val) * 100;

                  if ((temp > minLimit) && (temp < maxLimit))
                    color = 'rgb(60, 171, 48)';
                  else
                    color = 'rgb(255, 184, 29)';

                  let min = rfr / (1 - minLimit / 100),
                      max = rfr / (1 - maxLimit / 100);

                  this.chartData[params[p] + c].series[1].data.push({
                    x: dt,
                    low: min,
                    high: max
                  });
                }
              }

              if (val != -1000)
                this.chartData[params[p] + c].series[0].data.push({
                  x: dt,
                  y: val,
                  color: color
                });
            }
          }
        }

        params = ['tcspeed', 'tTurbIn', 'tcTbroilIn', 'tcTbroilO'];
        refs = ['tcspeed', 'tTurbIn', 'tcTbroilIn', 'tcTbroilO'];

        for (let c = 1; c <= this.tcCount; c++) {
          for (let p = 0; p < params.length; p++) {
            this.$set(this.chartData, params[p] + c, {
              credits: {enabled: false},
              time: {
                useUTC: false
              },
              chart: {
                height: 100,
                zoomType: 'xy'
              },
              xAxis: {
                type: 'datetime',
                title: {
                  text: 'Time',
                  align: 'high'
                },
                labels: {
                  format: '{value:%H:%M}'
                },
                crosshair: true
              },
              yAxis: {
                title: {
                  text: '[' + units[params[p]] + ']',
                  align: 'high'
                }
              },
              exporting: {
                enabled: false
              },
              tooltip: {
                formatter: function () {
                  return this.points.reduce(function (s, point) {
                    if (point.series.type == 'line') {
                      return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(2);
                    } else {
                      return s + '<br/>' + point.series.name + ': from ' + point.point.low.toFixed(2) + ' to ' + point.point.high.toFixed(2);
                    }
                  }, '<b>' + new Date(this.x).toTimeString().substring(0, 5) + '</b>');
                },
                shared: true
              },
              legend: {
                enabled: false
              },
              title: {
                text: undefined
              },
              series: [
                {
                  name: 'Value',
                  type: 'line',
                  color: 'transparent',
                  animation: false,
                  data: [],
                  marker:
                      {
                        radius: 2
                      },
                  states: {
                    hover: {
                      enabled: false
                    },
                    normal: {
                      animation: false
                    },
                    inactive: {
                      opacity: 1
                    }
                  }
                },
                {
                  name: 'Acceptable Range',
                  type: 'arearange',
                  animation: false,
                  data: [],
                  marker: {
                    enabled: false
                  },
                  color: 'rgb(219, 219, 219)',
                  fillOpacity: 0.6,
                  states: {
                    hover: {
                      enabled: false
                    },
                    normal: {
                      animation: false
                    },
                    inactive: {
                      opacity: 1
                    }
                  }
                }
              ]
            });

            // for (let i = 0; i < timeStamps.length; i++) {
            for (let i = 0; i < timeStamps.length; i += 3) {
              let val, rfr;

              val = globalStore.signals[timeStamps[i]][params[p] + c];

              if (globalStore.reference.timestamps.includes(timeStamps[i]))
                rfr = globalStore.reference[timeStamps[i]][refs[p] + c];
              else
                rfr = -1000;

              let color = 'rgb(51,82,128)';

              let dt = new Date(timeStamps[i]);

              if ((val != -1000) && (rfr != -1000) && (Object.keys(limits).includes(params[p]))) {
                let minLimit = limits[params[p]][0],
                    maxLimit = limits[params[p]][1];

                if ((minLimit != null) && (maxLimit != null)) {
                  let temp = ((val - rfr) / val) * 100;

                  if ((temp > minLimit) && (temp < maxLimit))
                    color = 'rgb(60, 171, 48)';
                  else
                    color = 'rgb(255, 184, 29)';

                  let min = rfr / (1 - minLimit / 100),
                      max = rfr / (1 - maxLimit / 100);

                  this.chartData[params[p] + c].series[1].data.push({
                    x: dt,
                    low: min,
                    high: max
                  });
                }
              }

              if (val != -1000)
                this.chartData[params[p] + c].series[0].data.push({
                  x: dt,
                  y: val,
                  color: color
                });
            }
          }
        }

        this.setLoadDiagram();

        let customTicks = [];
        for (let i = 10; i <= 110; i += 10) {
          customTicks.push(i);
        }

        this.$set(this.gaugeData, 'load', {
          value: globalStore.signals[timestamp]['ME_Power_perc'],
          rangeLimit: 100,
          startValue: 10,
          endValue: 110,
          customTicks: customTicks,
          //tickInterval:10,
          format: 1,
          unit: '[' + units['ME_Power_perc'] + ']',
          title: mapping['mapping']['ME_Power_perc']
        });

        if (this.gaugeData['load'].value == -1000 && globalStore.signals[timestamp]['load'] != -1000)
          this.gaugeData['load'].value = globalStore.signals[timestamp]['load'] * 100;

        let rpmMcr = Math.round(globalStore.loadDiagram['otVal2']),
            intNum = 10,
            lowSpeed = rpmMcr / 2,
            step = Math.ceil(lowSpeed / (intNum - 2)),
            tick = rpmMcr - (intNum - 1) * step;

        customTicks = [];
        customTicks.push(tick);

        for (let i = 0; i <= intNum; i++) {
          tick += step;
          customTicks.push(tick);
        }

        this.$set(this.gaugeData, 'ensp', {
          value: globalStore.signals[timestamp]['ensp'],
          rangeLimit: rpmMcr,
          startValue: customTicks[0],
          endValue: customTicks[intNum],
          tickInterval: step,
          customTicks: customTicks,
          format: 1,
          unit: '[rpm]',
          title: 'Engine Speed'
        });

        let xAxis = ['ensp', 'shaftP'];

        for (let x = 0; x < xAxis.length; x++) {
          let keys = Object.keys(globalStore.chartData.shopTestDataTier2);

          this.$set(this.isoData, xAxis[x], {});

          for (let i = 0; i < this.isoParams[xAxis[x]].length; i++) {
            let show = false, opposite = false, marginLeft = 15, marginRight = 15;

            if (i == this.isoParams[xAxis[x]].length - 1)
              show = true;

            if (i % 2 == 1) {
              opposite = true;
              marginLeft = 80;
            } else
              marginRight = 80;

            this.$set(this.isoData[xAxis[x]], this.isoParams[xAxis[x]][i][0], {
              credits: {enabled: false},
              chart: {
                backgroundColor: 'transparent',
                spacingLeft: marginLeft,
                spacingRight: marginRight,
                zoomType: 'xy'
              },
              legend: {
                enabled: show,
                align: 'center',
                verticalAlign: 'bottom',
                layout: 'horizontal'
              },
              title: {text: undefined},
              xAxis: {
                crosshair: true,
                title: {
                  text: mapping['mapping'][xAxis[x]] + " [" + units[xAxis[x]] + "]",
                  align: 'high'
                },
                visible: show
              },
              yAxis: {
                labels: {enabled: true},
                title: {
                  text: mapping['mapping'][this.isoParams[xAxis[x]][i][0].replace('_ISO', '')] + " [" + units[this.isoParams[xAxis[x]][i][0].replace('_ISO', '')] + "]",
                  align: 'high'
                }, opposite: opposite
              },
              exporting: {
                enabled: false
              },
              series: [
                {
                  name: 'Shoptest',
                  type: 'line',
                  data: [],
                  color: 'rgb(144,170,218)',
                  marker: {
                    enabled: false
                  },
                  states: {
                    hover: {
                      enabled: false
                    },
                    normal: {
                      animation: false
                    },
                    inactive: {
                      opacity: 1
                    }
                  }
                },
                {
                  name: 'Measured',
                  type: 'scatter',
                  data: [],
                  color: 'rgb(51,82,128)',
                  states: {
                    hover: {
                      enabled: false
                    },
                    normal: {
                      animation: false
                    },
                    inactive: {
                      opacity: 1
                    }
                  }
                }
              ]
            });

            if (this.isoParams[xAxis[x]][i].length > 1) {
              this.isoData[xAxis[x]][this.isoParams[xAxis[x]][i][0]].yAxis.title.text =
                  mapping['mapping'][this.isoParams[xAxis[x]][i][0].replace('_ISO', '')] + " / "
                  + mapping['mapping'][this.isoParams[xAxis[x]][i][1].replace('_ISO', '')] + " ["
                  + units[this.isoParams[xAxis[x]][i][0].replace('_ISO', '')] + "]";

              this.isoData[xAxis[x]][this.isoParams[xAxis[x]][i][0]].series.push({
                name: 'Shoptest',
                type: 'line',
                data: [],
                color: 'rgb(144,170,218)',
                marker: {
                  enabled: false
                },
                states: {
                  hover: {
                    enabled: false
                  },
                  normal: {
                    animation: false
                  },
                  inactive: {
                    opacity: 1
                  }
                }
              });
            }

            if (units[this.isoParams[xAxis[x]][i][0].replace('_ISO', '')] == null)
              this.isoData[xAxis[x]][this.isoParams[xAxis[x]][i][0]].yAxis.title.text =
                  mapping['mapping'][this.isoParams[xAxis[x]][i][0].replace('_ISO', '')] + " [-]";
          }

          let last = timestamp;

          for (let lp = 0; lp < this.isoParams[xAxis[x]].length; lp++) {
            let xLast = globalStore.signals[last][xAxis[x]];

            if (xLast == -1000 && xAxis[x] == 'shaftP') {
              let mcr = globalStore.loadDiagram['otVal1'];

              if (globalStore.signals[last]['ME_Power_kW'] != -1000)
                xLast = globalStore.signals[last]['ME_Power_kW'];
              else if (globalStore.signals[last]['load'] != -1000)
                xLast = globalStore.signals[last]['load'] * mcr;
            }

            if (xLast != -1000 && globalStore.signals[last][this.isoParams[xAxis[x]][lp][0].replace('_ISO', '')] != -1000)
              this.isoData[xAxis[x]][this.isoParams[xAxis[x]][lp][0]].series[1].data.push([
                xLast, globalStore.signals[last][this.isoParams[xAxis[x]][lp][0].replace('_ISO', '')]
              ]);
            else if ((this.isoParams[xAxis[x]][lp][0].replace('_ISO', '') == 'shaftP') && (globalStore.signals[last][this.isoParams[xAxis[x]][lp][0].replace('_ISO', '')] == -1000)) {
              let mcr = globalStore.loadDiagram['otVal1'],
                  yVal = -1000;

              if (globalStore.signals[last]['ME_Power_kW'] != -1000)
                yVal = globalStore.signals[last]['ME_Power_kW'];
              else if (globalStore.signals[last]['load'] != -1000)
                yVal = globalStore.signals[last]['load'] * mcr;

              if (yVal != -1000)
                this.isoData[xAxis[x]][this.isoParams[xAxis[x]][lp][0]].series[1].data.push([
                  xLast, yVal
                ]);
            }

            if (this.isoParams[xAxis[x]][lp].length > 1) {
              if (xLast != -1000 && globalStore.signals[last][this.isoParams[xAxis[x]][lp][1].replace('_ISO', '')] != -1000)
                this.isoData[xAxis[x]][this.isoParams[xAxis[x]][lp][0]].series[1].data.push([
                  xLast, globalStore.signals[last][this.isoParams[xAxis[x]][lp][1].replace('_ISO', '')]
                ]);
            }

            for (let i = 0; i < keys.length; i++) {
              let xValue = Number(globalStore.chartData.shopTestDataTier2[keys[i]][xAxis[x]]);

              this.isoData[xAxis[x]][this.isoParams[xAxis[x]][lp][0]].series[0].data.push([
                xValue, Number(globalStore.chartData.shopTestDataTier2[keys[i]][this.isoParams[xAxis[x]][lp][0]])
              ]);

              if (this.isoParams[xAxis[x]][lp].length > 1) {
                this.isoData[xAxis[x]][this.isoParams[xAxis[x]][lp][0]].series[2].data.push([
                  xValue, Number(globalStore.chartData.shopTestDataTier2[keys[i]][this.isoParams[xAxis[x]][lp][1]])
                ]);

              }
            }
          }
        }

        let keys = Object.keys(globalStore.chartData['controlLawsTier2']),
            last = timestamp;

        for (let i = 0; i < keys.length; i++) {

          let paramKeys = Object.keys(globalStore.chartData['controlLawsTier2'][keys[i]]);

          this.$set(this.tuningData, keys[i], {
            credits: {enabled: false},
            chart: {
              backgroundColor: 'transparent',
              zoomType: 'xy'
            },
            legend: {
              align: 'center',
              verticalAlign: 'bottom',
              layout: 'horizontal'
            },
            title: {text: undefined},
            xAxis: {
              crosshair: true,
              title: {
                text: mapping['mapping'][paramKeys[0].replace('_rel', '')] + " [" + units[paramKeys[0].replace('_rel', '')] + "]",
                align: 'high'
              }
            },
            yAxis: {
              labels: {enabled: true},
              title: {
                text: mapping['mapping'][paramKeys[1].replace('_rel', '')] + " [" + units[paramKeys[1].replace('_rel', '')] + "]",
                align: 'high'
              }
            },
            exporting: {
              enabled: false
            },
            series: [
              {
                name: 'Theoretical setting',
                type: 'line',
                data: [],
                color: 'rgb(144,170,218)',
                marker: {
                  enabled: false
                },
                states: {
                  hover: {
                    enabled: false
                  },
                  normal: {
                    animation: false
                  },
                  inactive: {
                    opacity: 1
                  }
                }
              },
              {
                name: 'Measured values',
                type: 'scatter',
                data: [],
                color: 'rgb(51,82,128)',
                states: {
                  hover: {
                    enabled: false
                  },
                  normal: {
                    animation: false
                  },
                  inactive: {
                    opacity: 1
                  }
                }
              }
            ]
          });

          if (paramKeys[0] == "load")
            this.tuningData[keys[i]].xAxis.title.text = 'Engine Load [%]';
          else if (paramKeys[0] == "pscav_rel")
            this.tuningData[keys[i]].xAxis.title.text = 'Scavenge Receiver Pressure [-]';
          else if (paramKeys[0] == "ensp_rel")
            this.tuningData[keys[i]].xAxis.title.text = 'Crank Shaft Rotational Speed [%]';


          if (paramKeys[1] == 'vec')
            this.tuningData[keys[i]].yAxis.title.text = 'VEC [deg]';
          else if (paramKeys[1] == 'veo')
            this.tuningData[keys[i]].yAxis.title.text = 'VEO [deg]';

          for (let j = 0; j < globalStore.chartData['controlLawsTier2'][keys[i]][paramKeys[0]].length; j++) {
            this.tuningData[keys[i]].series[0].data.push([
              globalStore.chartData['controlLawsTier2'][keys[i]][paramKeys[0]][j],
              globalStore.chartData['controlLawsTier2'][keys[i]][paramKeys[1]][j]
            ]);

            if (paramKeys[1] == "vec") {
              if (paramKeys[0] == 'pscav_rel') {
                let aBar = 0.5 * (globalStore.signals[last]['pAmb1'] + globalStore.signals[last]['pAmb2']);

                this.tuningData[keys[i]].series[1].data.push([
                  (globalStore.signals[last]['pscav'] + aBar) / (globalStore.signals[last]['pscav_cmcr'] + aBar),
                  globalStore.signals[last]['vec_' + paramKeys[0].replace('_rel', '')]
                ]);
              } else {
                this.tuningData[keys[i]].series[1].data.push([
                  globalStore.signals[last][paramKeys[0]],
                  globalStore.signals[last]['vec_' + paramKeys[0].replace('_rel', '')]
                ]);
              }
            } else if (paramKeys[0] == "load") {
              this.tuningData[keys[i]].series[1].data.push([
                100 * globalStore.signals[last][paramKeys[0]],
                globalStore.signals[last][paramKeys[1]]
              ]);

            } else if (paramKeys[1] == "vit_a") {
              let aBar = 0.5 * (globalStore.signals[last]['pAmb1'] + globalStore.signals[last]['pAmb2']);

              this.tuningData[keys[i]].series[1].data.push([
                (globalStore.signals[last]['pscav'] + aBar) / (globalStore.signals[last]['pscav_cmcr'] + aBar),
                globalStore.signals[last][paramKeys[1]]
              ]);
            } else {
              this.tuningData[keys[i]].series[1].data.push([
                globalStore.signals[last][paramKeys[0]],
                globalStore.signals[last][paramKeys[1]]
              ]);
            }
          }
        }

        this.signalsLeft = [];
        this.signalsRight = [];

        let available = Object.keys(globalStore.signals[last]),
            pAmb;

        for (let i = 0; i < this.fields.length; i++) {
          if (available.includes(this.fields[i])) {
            let val;

            if (globalStore.signals[last][this.fields[i]] != -1000)
              val = globalStore.signals[last][this.fields[i]].toFixed(2);
            else if (this.fields[i] == 'shaftP') {
              let mcr = globalStore.loadDiagram['otVal1'];

              if (globalStore.signals[last]['ME_Power_kW'] != -1000)
                val = globalStore.signals[last]['ME_Power_kW'].toFixed(2);
              else if (globalStore.signals[last]['load'] != -1000)
                val = (globalStore.signals[last]['load'] * mcr).toFixed(2);
              else
                val = 'N/A';
            } else
              val = 'N/A';

            let item = {
              name: mapping['mapping'][this.fields[i]],
              units: '[' + units[this.fields[i]] + ']',
              value: ((this.fields[i] == 'load') ? val * 100 : val)
            };

            if (this.fields[i] == 'load')
              item.units = '[%]';
            else if (units[this.fields[i]] == null)
              item.units = '[-]';

            this.signalsLeft.push(item);
          }
        }

        let average = (array) => array.reduce((a, b) => a + b) / array.length;

        for (let i = 0; i < this.avgFields.length; i++) {
          let forAvg = [];

          for (let c = 1; c <= this.cylCount; c++) {
            if ((available.includes(this.avgFields[i] + c)) && (globalStore.signals[last][this.avgFields[i] + c] != -1000))
              forAvg.push(globalStore.signals[last][this.avgFields[i] + c]);
          }

          let val;

          if (forAvg.length > 0)
            val = average(forAvg).toFixed(2);
          else
            val = 'N/A';

          let item = {
            name: mapping['mapping'][this.avgFields[i]],
            units: '[' + units[this.avgFields[i]] + ']',
            value: val
          };

          if (units[this.avgFields[i]] == null)
            item.units = '[-]';

          this.signalsLeft.push(item);
        }

        for (let i = 0; i < this.cylFields.length; i++) {
          for (let c = 1; c <= this.cylCount; c++) {
            let val;

            if ((available.includes(this.cylFields[i] + c)) && (globalStore.signals[last][this.cylFields[i] + c] != -1000))
              val = globalStore.signals[last][this.cylFields[i] + c].toFixed(2);
            else val = 'N/A';

            let item = {
              name: mapping['mapping'][this.cylFields[i]] + ' ' + c,
              units: '[' + units[this.cylFields[i]] + ']',
              value: val
            };

            if (units[this.cylFields[i]] == null)
              item.units = '[-]';

            this.signalsRight.push(item);
          }
        }

        for (let i = 0; i < this.tcFields.length; i++) {

          for (let tc = 1; tc <= this.tcCount; tc++) {
            let val;

            if ((available.includes(this.tcFields[i] + tc)) && (globalStore.signals[last][this.tcFields[i] + tc] != -1000))
              val = globalStore.signals[last][this.tcFields[i] + tc].toFixed(2);
            else val = 'N/A';

            let item = {
              name: mapping['mapping'][this.tcFields[i]] + ' ' + tc,
              units: '[' + units[this.tcFields[i]] + ']',
              value: val
            };

            if (units[this.tcFields[i]] == null)
              item.units = '[-]';

            this.signalsRight.push(item);
          }
        }

        for (let i = 0; i < this.meanFields.length; i++) {
          let forAvg = [];

          for (let j = 1; j <= 2; j++) {
            if ((available.includes(this.meanFields[i] + j)) && (globalStore.signals[last][this.meanFields[i] + j] != -1000))
              forAvg.push(globalStore.signals[last][this.meanFields[i] + j]);
          }

          let val;

          if (forAvg.length > 0) {
            val = average(forAvg).toFixed(2);
            if (this.meanFields[i] == 'pAmb')
              pAmb = average(forAvg);
          } else
            val = 'N/A';

          let item = {
            name: mapping['mapping'][this.meanFields[i]],
            units: '[' + units[this.meanFields[i]] + ']',
            value: val
          };

          if (units[this.meanFields[i]] == null)
            item.units = '[-]';

          this.signalsRight.push(item);
        }

        let pCompScav = {
          name: 'Pcomp / pscav',
          units: '[-]',
          value: ((globalStore.signals[last]['pcomp'] + pAmb) / (globalStore.signals[last]['pscav'] + pAmb)).toFixed(2)
        };

        this.signalsRight.push(pCompScav);

        setTimeout(() => {
          this.active = true;
        });
      }
    },
    setLoadDiagram() {
      var refLength = Object.keys(globalStore.reference).length,
          sigLength = Object.keys(globalStore.signals).length,
          key = ((refLength > sigLength) ? 'signals' : 'reference'),
          timeStamps = globalStore[key].timestamps,
          timestamp = timeStamps[timeStamps.length - 1];

      this.loadDiagram = {
        credits: {enabled: false},
        chart: {
          height: 340
        },
        legend: {
          enabled: true
        },
        tooltip: {
          formatter: function () {
            return this.points.reduce(function (s, point) {
              return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(0);
            }, '<b>' + this.x + ' rpm</b>');
          },
          shared: true
        },
        title: {
          text: undefined
        },
        xAxis: {
          title: {
            text: 'Engine speed [rpm]',
            align: 'high'
          },
          crosshair: true
        },
        yAxis: {
          title: {
            text: 'Shaft power [kW]',
            align: 'high'
          }
        },
        exporting: {
          enabled: false
        },
        series: [
          {
            name: 'Measured',
            type: 'scatter',
            data: [],
            animation: false,
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            }
          },
          {
            name: 'Reference',
            type: 'scatter',
            data: [],
            animation: false,
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            }
          },
          {
            name: 'Shop Tests',
            type: 'spline',
            data: [],
            animation: false,
            marker: {
              enabled: false
            },
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            }
          },
          {
            name: 'Sea Trials',
            type: 'line',
            data: [],
            animation: false,
            marker: {
              enabled: false
            },
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            }
          },
          {
            name: 'Engine Limit',
            type: 'line',
            data: [],
            animation: false,
            marker: {
              enabled: false
            },
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            }
          }
        ]
      };

      // let refLength = Object.keys(globalStore.reference).length,
      //     sigLength = Object.keys(globalStore.signals).length,
      //     mcr = ((typeof globalStore.loadDiagram['otVal1'] != 'undefined') ? globalStore.loadDiagram['otVal1'] : 0),
      //     key = ((refLength > sigLength) ? 'signals' : 'reference'),
      //     timeStamps = globalStore[key].timestamps,
      //     timestamp = timeStamps[timeStamps.length - 1];
      //
      // if (Object.keys(globalStore.signals).indexOf('average') > -1) {
      //   timestamp = 'average';
      // }
      //
      // if (globalStore.signals[timestamp]['ensp'] != -1000) {
      //   if (typeof globalStore.signals[timestamp]['shaftP'] != 'undefined' && globalStore.signals[timestamp]['shaftP'] != -1000)
      //     this.loadDiagram.series[0].data = [[globalStore.signals[timestamp]['ensp'], globalStore.signals[timestamp]['shaftP']]];
      //   else if (typeof globalStore.signals[timestamp]['ME_Power_kW'] != 'undefined' && globalStore.signals[timestamp]['ME_Power_kW'] != -1000)
      //     this.loadDiagram.series[0].data = [[globalStore.signals[timestamp]['ensp'], globalStore.signals[timestamp]['ME_Power_kW']]];
      //   else if (typeof globalStore.signals[timestamp]['load'] != 'undefined' && globalStore.signals[timestamp]['load'] != -1000)
      //     this.loadDiagram.series[0].data = [[globalStore.signals[timestamp]['ensp'], globalStore.signals[timestamp]['load'] * mcr]];
      //   else
      //     this.loadDiagram.series[0].data = [[globalStore.signals[timestamp]['ensp'], 0]];
      //
      //   if (typeof globalStore.reference[timestamp]['shaftP'] != 'undefined' && globalStore.reference[timestamp]['shaftP'] != -1000)
      //     this.loadDiagram.series[1].data = [[globalStore.signals[timestamp]['ensp'], globalStore.reference[timestamp]['shaftP']]];
      //   else if (typeof globalStore.reference[timestamp]['ME_Power_kW'] != 'undefined' && globalStore.reference[timestamp]['ME_Power_kW'] != -1000)
      //     this.loadDiagram.series[1].data = [[globalStore.signals[timestamp]['ensp'], globalStore.reference[timestamp]['ME_Power_kW']]];
      //   else if (typeof globalStore.reference[timestamp]['load'] != 'undefined' && globalStore.reference[timestamp]['load'] != -1000)
      //     this.loadDiagram.series[1].data = [[globalStore.signals[timestamp]['ensp'], globalStore.reference[timestamp]['load'] * mcr]];
      //   else
      //     this.loadDiagram.series[1].data = [[globalStore.signals[timestamp]['ensp'], 0]];
      // }
      //
      // if (typeof this.loadDiagram.series[0].data[0] != 'undefined' && typeof this.loadDiagram.series[1].data[0] != 'undefined'
      //     && this.loadDiagram.series[0].data[0][0] == this.loadDiagram.series[1].data[0][0] && this.loadDiagram.series[0].data[0][1] == this.loadDiagram.series[1].data[0][1]) {
      //   if (this.loadDiagram.series[0].data[0].length < 1 || (!this.loadDiagram.series[0].data[0][0] && !this.loadDiagram.series[0].data[0][1]))
      //     this.loadDiagram.series[0].data = [];
      //
      //   if (this.loadDiagram.series[1].data[0].length < 1 || (!this.loadDiagram.series[1].data[0][0] && !this.loadDiagram.series[1].data[0][1]))
      //     this.loadDiagram.series[1].data = [];
      // }

      let mcr = globalStore.loadDiagram['otVal1'];

      this.loadDiagram.series[0].data = [];
      this.loadDiagram.series[1].data = [];

      if (globalStore.type == 'last') {
        let ensp = globalStore.signals[timestamp]['ensp'];

        if ((ensp != -1000)&&(ensp != 0)) {
          if (typeof globalStore.signals[timestamp]['shaftP'] != 'undefined' && globalStore.signals[timestamp]['shaftP'] != -1000)
            this.loadDiagram.series[0].data.push([ensp, globalStore.signals[timestamp]['shaftP']]);
          else if (typeof globalStore.signals[timestamp]['ME_Power_kW'] != 'undefined' && globalStore.signals[timestamp]['ME_Power_kW'] != -1000)
            this.loadDiagram.series[0].data.push([ensp, globalStore.signals[timestamp]['ME_Power_kW']]);
          else if (typeof globalStore.signals[timestamp]['load'] != 'undefined' && globalStore.signals[timestamp]['load'] != -1000)
            this.loadDiagram.series[0].data.push([ensp, globalStore.signals[timestamp]['load'] * mcr]);
          else
            this.loadDiagram.series[0].data.push([ensp, 0]);

          if (typeof globalStore.reference[timestamp]['shaftP'] != 'undefined' && globalStore.reference[timestamp]['shaftP'] != -1000)
            this.loadDiagram.series[1].data.push([ensp, globalStore.reference[timestamp]['shaftP']]);
          else if (typeof globalStore.reference[timestamp]['ME_Power_kW'] != 'undefined' && globalStore.reference[timestamp]['ME_Power_kW'] != -1000)
            this.loadDiagram.series[1].data.push([ensp, globalStore.reference[timestamp]['ME_Power_kW']]);
          else if (typeof globalStore.reference[timestamp]['load'] != 'undefined' && globalStore.reference[timestamp]['load'] != -1000)
            this.loadDiagram.series[1].data.push([ensp, globalStore.reference[timestamp]['load'] * mcr]);
          else
            this.loadDiagram.series[1].data.push([ensp, 0]);
        }
      } else {
        for (let i=0;i<globalStore.signals.timestamps.length;i++)
        {
          let ts = globalStore.signals.timestamps[i];

          let ensp = globalStore.signals[ts]['ensp'];

          if ((ensp != -1000)&&(ensp != 0)) {
            if (typeof globalStore.signals[ts]['shaftP'] != 'undefined' && globalStore.signals[ts]['shaftP'] != -1000)
              this.loadDiagram.series[0].data.push([ensp, globalStore.signals[ts]['shaftP']]);
            else if (typeof globalStore.signals[ts]['ME_Power_kW'] != 'undefined' && globalStore.signals[ts]['ME_Power_kW'] != -1000)
              this.loadDiagram.series[0].data.push([ensp, globalStore.signals[ts]['ME_Power_kW']]);
            else if (typeof globalStore.signals[ts]['load'] != 'undefined' && globalStore.signals[ts]['load'] != -1000)
              this.loadDiagram.series[0].data.push([ensp, globalStore.signals[ts]['load'] * mcr]);
            else
              this.loadDiagram.series[0].data.push([ensp, 0]);

            if (typeof globalStore.reference[ts]['shaftP'] != 'undefined' && globalStore.reference[ts]['shaftP'] != -1000)
              this.loadDiagram.series[1].data.push([ensp, globalStore.reference[ts]['shaftP']]);
            else if (typeof globalStore.reference[ts]['ME_Power_kW'] != 'undefined' && globalStore.reference[ts]['ME_Power_kW'] != -1000)
              this.loadDiagram.series[1].data.push([ensp, globalStore.reference[ts]['ME_Power_kW']]);
            else if (typeof globalStore.reference[ts]['load'] != 'undefined' && globalStore.reference[ts]['load'] != -1000)
              this.loadDiagram.series[1].data.push([ensp, globalStore.reference[ts]['load'] * mcr]);
            else
              this.loadDiagram.series[1].data.push([ensp, 0]);
          }
        }
      }

      this.loadDiagram.series[2].data = [];
      if (typeof globalStore.loadDiagram.spVal1 != 'undefined') {
        for (let i = 0; i < globalStore.loadDiagram.spVal1.length; i++) {
          this.loadDiagram.series[2].data.push([globalStore.loadDiagram['spVal1'][i], globalStore.loadDiagram['spVal7'][i]])
        }
      }

      this.loadDiagram.series[3].data = [];
      if (typeof globalStore.loadDiagram.spVal1 != 'undefined') {
        for (let i = 0; i < globalStore.loadDiagram.stVal1.length; i++) {
          this.loadDiagram.series[3].data.push([globalStore.loadDiagram['stVal1'][i], globalStore.loadDiagram['stVal2'][i]])
        }
      }

      this.loadDiagram.series[4].data = [];

      let rpmMin = ((typeof globalStore.loadDiagram['otVal3'] != 'undefined') ? globalStore.loadDiagram['otVal3'] : 0),
          rpmMcr = ((typeof globalStore.loadDiagram['otVal2'] != 'undefined') ? globalStore.loadDiagram['otVal2'] : 0),
          mcr97 = ((typeof globalStore.loadDiagram['otVal4'] != 'undefined') ? globalStore.loadDiagram['otVal4'] : 0),
          rpm105 = ((typeof globalStore.loadDiagram['otVal5'] != 'undefined') ? globalStore.loadDiagram['otVal5'] : 0),
          RPMStep = 5.0,
          load = globalStore.signals[timestamp]['load'] * 100;

      this.loadDiagram.series[4].data.push([rpmMin, 0]);

      let aPWR,
          aRPM = rpmMin;

      do {
        aPWR = mcr97 * Math.pow((aRPM / (0.97 * rpmMcr)), 2.0);
        this.loadDiagram.series[4].data.push([aRPM, aPWR]);
        aRPM = aRPM + RPMStep;
      } while (aRPM <= 0.97 * rpmMcr);

      this.loadDiagram.series[4].data.push([0.97 * rpmMcr, mcr97]);
      this.loadDiagram.series[4].data.push([rpmMcr, mcr]);

      this.loadDiagram.series[4].data.push([rpm105, mcr]);

      this.loadDiagram.series[4].data.push([rpm105, 0]);

    },
    testPDF() {
      var mapping = globalStore.mapping[globalStore.selectedIMO],
          units = globalStore.units[globalStore.selectedIMO],
          limits = globalStore.limits[globalStore.selectedIMO];

      if (typeof mapping == 'undefined') {
        mapping = globalStore.mapping[Object.keys(globalStore.mapping)[0]]
      }

      if (typeof units == 'undefined') {
        units = globalStore.units[Object.keys(globalStore.units)[0]]
      }

      if (typeof limits == 'undefined') {
        limits = globalStore.limits[Object.keys(globalStore.limits)[0]]
      }

      let target_vessel = vessels.vessels.filter((vessel) => {
        return vessel.imo == globalStore.selectedIMO
      })[0];

      let forPDF = {
        vessel: globalStore.selectedVessel,
        imo: globalStore.selectedIMO,
        engine: (target_vessel.has_twin ? globalStore.selectedEngine : ''),
        type: globalStore.type,
        cylCount: globalStore.cylCount,
        tcCount: globalStore.tcCount,
        mapping: mapping['mapping'],
        units: units,
        limits: limits,
        showAdditional: this.showAdditional,
        gaugeData: this.gaugeData,
        gasEngine: globalStore.gasEngine,

        date: Object.keys(globalStore.signals)[0],
        engineData: this.engineData,
        subSystemData: this.subSystemData,
        chartData: this.chartData,
        userId: globalStore.userProfile.id,
        loadDiagram: this.loadDiagram.series.map(function (item) {
          return item.data;
        })
      };

      let date = Object.keys(globalStore.signals)[0].substring(0, 10),
          reportName = 'edsReport_' + globalStore.selectedVessel + '_' + date + '.pdf';

      if (globalStore.twinEngine)
        reportName = 'WiDEReport_' + globalStore.selectedVessel + '_' + globalStore.selectedEngine + '_' + date + '.pdf';

      globalStore.loading = true;

      axios.post(globalStore.config.api_location + ':' + globalStore.config.report_server_port + '/api/reportinitiate/', forPDF, {responseType: 'blob'}).then(response => {
        try {
          var url = window.URL.createObjectURL(new Blob([response.data])),
              link = document.createElement('a');

          link.href = url;
          link.setAttribute('download', reportName); //or any other extension
          document.body.appendChild(link);
          link.click();
        } catch (e) {
          console.log(e)
        }

        globalStore.loading = false;
      });
    },
    createPDF() {
      document.body.style.cursor = 'progress';

      var Highcharts = require('highcharts');

      var options = Highcharts.merge(Highcharts.getOptions().exporting, {type: 'application/pdf'});

      var svgArr = [], top = 0, width = 0;

      let charts = Highcharts.charts.filter(function (item) {
        if (item != undefined) return item.renderTo.className == 'report';
      });

      let prTitle;

      for (let i = 0; i < charts.length; i++) {
        if (charts[i].container.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.previousElementSibling != prTitle) {
          prTitle = charts[i].container.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.previousElementSibling;

          var overTitle = '<g transform="translate(0,' + top + ')" width="' + prTitle.clientWidth +
              '" height="' + prTitle.clientHeight + '" ><text x="15" y="15" fill="rgb(51,82,128)" style="font-size: 20px !important;font-weight: 500;line-height: 1 !important;letter-spacing: 0.02em !important;font-family: &quot;Roboto&quot;, sans-serif !important;">' + prTitle.innerText + '</text></g>';

          top += prTitle.clientHeight;

          svgArr.push(overTitle);
        }

        var title = charts[i].container.parentElement.parentElement.previousElementSibling,
            titleSVG = '<g transform="translate(0,' + top + ')" width="' + title.clientWidth +
                '" height="' + title.clientHeight + '" ><text x="15" y="15" fill="rgb(33,33,33)" style="font-size: 14px !important;font-weight: 500;line-height: 1 !important;letter-spacing: 0.02em !important;font-family: &quot;Roboto&quot;, sans-serif !important;">' + title.innerText + '</text></g>';

        top += title.clientHeight;

        svgArr.push(titleSVG);

        var svg = charts[i].getSVG(),
            svgWidth = +svg.match(
                /^<svg[^>]*width\s*=\s*\"?(\d+)\"?[^>]*>/
            )[1],
            svgHeight = +svg.match(
                /^<svg[^>]*height\s*=\s*\"?(\d+)\"?[^>]*>/
            )[1];

        svg = svg.replace(
            '<svg',
            '<g transform="translate(0,' + top + ')" '
        );
        svg = svg.replace('</svg>', '</g>');

        top += svgHeight;
        width = Math.max(width, svgWidth);

        svgArr.push(svg);
      }

      let svgFile = '<svg height="' + top + '" width="' + width +
          '" version="1.1" xmlns="http://www.w3.org/2000/svg">' +
          svgArr.join('') + '</svg>';

      var temp = Object.keys(globalStore.reference);

      if (temp.indexOf('average') > -1)
        temp.splice(temp.indexOf('average'), 1);

      var dateString = "";

      if ((globalStore.type == 'today') || (globalStore.type == 'last')) dateString = temp[temp.length - 1];
      else dateString = new Date(temp[temp.length - 2]).toISOString().slice(0, 10);

      Highcharts.post(options.url, {
        filename: "WiDEReport_" + globalStore.selectedVessel + "_" + dateString,
        width: options.width,
        type: options.type,
        svg: svgFile
      });

      document.body.style.cursor = 'default';

    }

  },
  watch: {
    dataLoaded: function () {
      setTimeout(() => {
        this.setData();
      }, 600);
    }
  }
}

</script>

<style scoped>

.perfTable {
  font-size: 16px;
  font-family: 'Roboto', 'sans seriff';
  height: 100% !important;
}

</style>

<style>
.report-chart .title {
  height: initial !important;
}

.gauge {
  width: 100% !important;
  min-width: 100%;
}

.gauge .v-card__title title {
  width: 100% !important;
}

.gauge .v-card__actions {
  width: 100% !important;
}

.gauge .dx-visibility-change-handler {
  height: auto !important;
}

</style>
